import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "lib/apiInstance";
import { LOCAL_STORAGE } from "utils/constant";
import { BASE_URL, EndpointsSlug } from "./endpoints";

export const missionService = createApi({
  reducerPath: "missionService",
  baseQuery: baseQueryWithReauth({
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem(LOCAL_STORAGE.USER_TOKEN) || "";
      headers.set("Content-type", "application/json; charset=UTF-8");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["daily_mission"],
  endpoints: (builder) => ({
    getMissionsAdmin: builder.query({
      query: (params) => ({
        url: "/admin/mission/get",
        method: "GET",
        params,
      }),
      providesTags: ["daily_mission"],
    }),
    createMission: builder.mutation({
      query: (data) => ({
        url: "/admin/mission/create",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["daily_mission"],
    }),
    updateMission: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/admin/mission/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["daily_mission"],
    }),
    toggleMissionStatus: builder.mutation({
      query: (id) => ({
        url: `/admin/mission/${id}/toggle`,
        method: "PATCH",
      }),
      invalidatesTags: ["daily_mission"],
    }),
    deleteMission: builder.mutation({
      query: (id) => ({
        url: `/admin/mission/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["daily_mission"],
    }),
  }),
});

export const {
  useGetMissionsAdminQuery,
  useCreateMissionMutation,
  useUpdateMissionMutation,
  useToggleMissionStatusMutation,
  useDeleteMissionMutation,
} = missionService;
